import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { Check, Minus } from 'lucide-react'
import { cn } from '@/lib/cn'

type CheckboxProps = React.ComponentPropsWithRef<typeof CheckboxPrimitive.Root>

const Checkbox = React.forwardRef<
  React.ComponentRef<typeof CheckboxPrimitive.Root>,
  CheckboxProps
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    // `checked="indeterminate"` is native to Radix: it sets aria-checked="mixed" and
    // data-state="indeterminate". EW-T12 needs it for three-state group headers, where a
    // partially-selected group must be visually distinct from both checked and unchecked —
    // a tick would claim the whole group is selected. Consumers passing true/false are
    // unaffected.
    className={cn(
      'peer h-4 w-4 shrink-0 rounded-sm border border-input-border shadow-xs',
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
      'disabled:cursor-not-allowed disabled:opacity-50',
      'data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground data-[state=checked]:border-primary',
      'data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-primary-foreground data-[state=indeterminate]:border-primary',
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
      {props.checked === 'indeterminate'
        ? <Minus className="h-3.5 w-3.5" />
        : <Check className="h-3.5 w-3.5" />}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = 'Checkbox'

export { Checkbox, type CheckboxProps }
